<template lang="pug">
  .user-team-list
    template(v-if="!isTeamLoading")
      .user-team-table(v-if="teamLeader")
        .user-team-table__head.user-team-person
          .user-team-person__img-wrapper
            img(
              :src="teamLeader.avatar || defaultAvatar"
              alt=""
            ).user-team-person__img

          .user-team-person__info
            p.user-team-person__name {{teamLeaderName}}
            p.user-team-person__city Капитан

      ul.user-team-table(
        :style="{'grid-template-columns': gridLayout}"
      )
        HeaderCell(
          v-for="cell in titleList" :key="cell.id"
        ) {{cell.title}}

      BodyRow(
        v-for="user in currentTeam.users" :key="user.id"
        :team="team"
        :leader="localLeader"
        :gridLayout="gridLayout"
        :user="user"
        :folderId="folderId"

        :isSmart="!canEdit"
        :canSetLeader="canEdit"
        :canChangeTeam="canEdit"
        :canDeleteUser="canEdit"
        :showEmail="canEdit"
        :showFaculty="true"

        @setLeader="setLeader"
      )

    template(v-else)
      SkeletonRow

</template>

<script>
import HeaderCell from './components/HeaderCell';
import BodyRow from './components/BodyRow';
import SkeletonRow from '../../../Body/components/SkeletonRow';
import { mapState } from 'vuex';

export default {
  components: {
    HeaderCell,
    BodyRow,
    SkeletonRow
  },
  props: {
    team: {},
    folderId: {}
  },
  data: () => ({
    isTeamLoading: false,
    fullTitleList: [
      {
        id: 0,
        title: 'Контакты',
        width: '2fr'
      },
      {
        id: 1,
        title: 'Telegram',
        width: '1fr'
      },
      {
        id: 2,
        title: 'Email',
        width: '1fr'
      },
      {
        id: 3,
        title: 'Факультет / Сборная',
        width: '1fr'
      },
      {
        id: 4,
        title: 'Уроков открыто',
        width: '1fr'
      },
      {
        id: 5,
        title: 'Уроков пройдено',
        width: '1fr'
      },
      {
        id: 6,
        title: 'Уроков проверено',
        width: '1fr'
      },
      {
        id: 7,
        title: 'Настройки',
        width: '145px'
      }
    ],
    smartTitleList: [
      {
        id: 0,
        title: 'Контакты',
        width: '1fr'
      },
      {
        id: 1,
        title: 'Telegram',
        width: '1fr'
      }
    ],
    userList: [],
    defaultAvatar: '/lms/img/user-default.jpg',
    localLeader: null
  }),
  computed: {
    ...mapState('teamGroup', {
      teams: s => s.data.teams,
      canEdit: s => s.data.settings.canEdit
      // isTeamLoading: s => s.meta.isTeamLoading,
    }),
    titleList() {
      return this.canEdit ? this.fullTitleList : this.smartTitleList;
    },
    gridLayout() {
      const result = [];

      this.titleList.forEach(prop => {
        result.push(prop.width || this.defaultWidth);
      });

      return result.join(' ');
    },
    currentTeam() {
      const team = this.teams.find(item => item.id === this.team.id);
      return team ? team : {};
    },
    teamLeader() {
      return this.currentTeam.captain;
    },
    teamLeaderName() {
      if (this.teamLeader.name || this.teamLeader.lastname) {
        return `${this.teamLeader.name} ${this.teamLeader.lastname}`;
      } else {
        return 'Аноним';
      }
    }
  },
  watch: {
    // 'currentTeam.leader'(leader) {
    //   this.setLeader(leader)
    // }
    isTeamLoading(value) {
      if (!value) {
        this.setLeader(this.currentTeam.leader);
      }
    }
  },
  mounted() {
    this.getTeamsData();
    this.setLeader(this.currentTeam.leader);
  },
  methods: {
    async getTeamsData() {
      if (this.teams.findIndex(item => item.id === this.team.id) === -1) {
        this.isTeamLoading = true;
        await this.$store.dispatch('teamGroup/getTeamsData', this.team.id);
        this.isTeamLoading = false;
      }
    },
    setLeader(leader) {
      this.localLeader = leader;
    }
  }
};
</script>
